import { all, takeLatest } from 'lib/redux';
import {
  LOAD_ORDER_HISTORY_PAGE, UPDATE_PAGE_OPTIONS,
  ORDER_HISTORY_APPLY_FILTERS,
  GET_ORG_DESCENDANTS,
} from 'constants/ActionTypes';
import { getOrgDescendantsSaga } from 'features/userData/UserData.saga';
import {
  applyFiltersSaga, loadOrderHistorySaga, updatePageOptionsSaga,
} from './OrderHistory.saga';

/**
 * Defines the watchers related to OrderHistory Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(LOAD_ORDER_HISTORY_PAGE, loadOrderHistorySaga),
    takeLatest(UPDATE_PAGE_OPTIONS, updatePageOptionsSaga),
    takeLatest(ORDER_HISTORY_APPLY_FILTERS, applyFiltersSaga),
    takeLatest(GET_ORG_DESCENDANTS, getOrgDescendantsSaga),
  ]);
}
